export const VISUAL_SEARCH = "visual search"
export const VISUAL_SEARCH_RESULT = "visual search results"
export const NAVIGATION = "navigation"
export const GLOBAL_HEADER = "global header"
export const GLOBAL_NAV = "global navigation"
export const FAILURE = "failure"
export const SUCCESS = "success"
export const INCORRECT_EVENT_MESSAGE =
  "Sorry, we weren’t able to identify your Kohler product"
export const SEARCH_RESULT = "search results displayed"
export const VSEARCH_RESULT = "visual search results displayed"
export const SUCCESS_MESASGE = "Image uploaded and successfully fetched results"
export const FAILURE_MESSAGE = "Error in fetching results"
